import { useState } from "react";
import { cn } from "@/lib/utils";
import { Stars } from "./stars";
import { ReviewsDialog } from "./reviews-dialog";
import { formatarNota } from "./format";
import { useLandingReviews } from "./use-reviews";

/**
 * Selo compacto de nota, para usar acima da dobra (Hero).
 *
 * Renderiza `null` enquanto o resumo não chegou e quando há poucas avaliações.
 * Não existe skeleton aqui de propósito: um placeholder cinza logo abaixo do
 * H1 rouba a atenção do headline e, quando o dado chega, empurra a página
 * (layout shift medido no CLS). Melhor o selo aparecer sem reservar espaço.
 */
export function RatingBadge({ className }: { className?: string }) {
  const { data, suficiente } = useLandingReviews();
  const [aberto, setAberto] = useState(false);

  if (!data || !suficiente) return null;

  return (
    <>
      <div className={cn("flex", className)}>
        <button
          type="button"
          onClick={() => setAberto(true)}
          className={cn(
            "group inline-flex items-center gap-2.5 rounded-full border border-border bg-card",
            "pl-3.5 pr-4 py-1.5 shadow-xs transition-colors",
            "hover:border-lp-rating/50 hover:bg-lp-rating/5",
            "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
          )}
        >
          <Stars value={data.average} size="sm" />
          <span className="text-sm font-semibold text-foreground tabular-nums">
            {formatarNota(data.average)}
          </span>
          <span className="text-xs text-muted-foreground group-hover:text-foreground transition-colors">
            {data.total} {data.total === 1 ? "avaliação" : "avaliações"}
            <span className="hidden sm:inline"> de líderes</span>
          </span>
        </button>
      </div>

      <ReviewsDialog open={aberto} onOpenChange={setAberto} data={data} />
    </>
  );
}
